import { useEffect, useState } from "react";
/**
 * A value that lags behind, so a search box does not fire a request per
 * keystroke.
 *
 * The field itself stays controlled and instant: the caller keeps the typed
 * value in its own state and renders that, and keys the query off what this
 * returns. Debouncing inside `SearchInput` would mean either a laggy field or a
 * second copy of the value inside a component whose whole contract is that the
 * caller owns it.
 *
 * The timer is reset on every change and cleared on unmount, so a field that is
 * still being typed into never resolves and a screen the operator has left
 * never sets state on a component that is gone.
 *
 * `delay` of 0 still defers by a tick. That is deliberate: a caller asking for
 * no delay wants no debounce, and should not use this at all.
 */
export function useDebouncedValue(value, delay = 250) {
    const [settled, setSettled] = useState(value);
    useEffect(() => {
        const timer = setTimeout(() => {
            setSettled(value);
        }, delay);
        return () => {
            clearTimeout(timer);
        };
    }, [value, delay]);
    return settled;
}
//# sourceMappingURL=use-debounced-value.js.map